/* ============================================================
   TAPIOS PROVISIONS - THEME JS
   Vanilla JavaScript - No jQuery
   ============================================================ */

document.addEventListener('DOMContentLoaded', function () {

  /* ----------------------------------------------------------
     MOBILE MENU TOGGLE
  ---------------------------------------------------------- */
  const mobileMenuBtn = document.querySelector('.mobile-menu-btn');
  const mobileNav = document.querySelector('.mobile-nav');

  if (mobileMenuBtn && mobileNav) {
    mobileMenuBtn.addEventListener('click', function () {
      const isOpen = mobileNav.classList.toggle('is-open');
      mobileMenuBtn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      const spans = mobileMenuBtn.querySelectorAll('span');
      if (isOpen) {
        spans[0] && (spans[0].style.transform = 'rotate(45deg) translate(5px, 5px)');
        spans[1] && (spans[1].style.opacity = '0');
        spans[2] && (spans[2].style.transform = 'rotate(-45deg) translate(5px, -5px)');
      } else {
        spans[0] && (spans[0].style.transform = '');
        spans[1] && (spans[1].style.opacity = '');
        spans[2] && (spans[2].style.transform = '');
      }
    });
  }

  /* ----------------------------------------------------------
     STICKY HEADER SCROLL BEHAVIOR
  ---------------------------------------------------------- */
  const siteHeader = document.querySelector('.site-header');
  const headerWrapper = document.querySelector('.header-wrapper');
  let lastScrollY = window.scrollY;

  if (headerWrapper) {
    window.addEventListener('scroll', function () {
      const currentScrollY = window.scrollY;
      if (currentScrollY > 80) {
        headerWrapper.classList.add('is-scrolled');
      } else {
        headerWrapper.classList.remove('is-scrolled');
      }
      lastScrollY = currentScrollY;
    }, { passive: true });
  }

  /* ----------------------------------------------------------
     QUANTITY +/- BUTTONS
  ---------------------------------------------------------- */
  function initQtyButtons() {
    document.querySelectorAll('.qty-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        const input = this.closest('.qty-selector') && this.closest('.qty-selector').querySelector('.qty-input');
        if (!input) return;
        let val = parseInt(input.value, 10) || 1;
        if (this.dataset.action === 'increase') {
          val = val + 1;
        } else if (this.dataset.action === 'decrease') {
          val = Math.max(1, val - 1);
        }
        input.value = val;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  }
  initQtyButtons();

  /* ----------------------------------------------------------
     VARIANT SELECTION ON PDP
  ---------------------------------------------------------- */
  const variantButtons = document.querySelectorAll('.variant-btn');
  const variantInput = document.querySelector('input[name="id"]');
  const pdpPrice = document.querySelector('.pdp-price');
  const pdpPriceCompare = document.querySelector('.pdp-price-compare');
  const atcBtn = document.querySelector('.atc-btn');

  if (variantButtons.length > 0) {
    variantButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (this.classList.contains('unavailable')) return;
        variantButtons.forEach(function (b) { b.classList.remove('active'); });
        this.classList.add('active');
        const variantId = this.dataset.variantId;
        const variantPrice = this.dataset.variantPrice;
        const variantComparePrice = this.dataset.variantComparePrice;
        const available = this.dataset.variantAvailable !== 'false';

        if (variantInput) variantInput.value = variantId;

        if (pdpPrice && variantPrice) {
          pdpPrice.textContent = formatMoney(parseInt(variantPrice, 10));
        }
        if (pdpPriceCompare) {
          if (variantComparePrice && parseInt(variantComparePrice, 10) > parseInt(variantPrice, 10)) {
            pdpPriceCompare.textContent = formatMoney(parseInt(variantComparePrice, 10));
            pdpPriceCompare.style.display = '';
          } else {
            pdpPriceCompare.style.display = 'none';
          }
        }
        if (atcBtn) {
          if (!available) {
            atcBtn.textContent = 'Sold Out';
            atcBtn.disabled = true;
          } else {
            atcBtn.textContent = 'Add to Cart';
            atcBtn.disabled = false;
          }
        }
      });
    });
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  /* ----------------------------------------------------------
     PDP TAB SWITCHING
  ---------------------------------------------------------- */
  const tabButtons = document.querySelectorAll('.pdp-tab-btn');
  const tabPanels = document.querySelectorAll('.pdp-tab-panel');

  if (tabButtons.length > 0) {
    tabButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        const targetTab = this.dataset.tab;
        tabButtons.forEach(function (b) { b.classList.remove('active'); });
        tabPanels.forEach(function (p) { p.classList.remove('active'); });
        this.classList.add('active');
        const targetPanel = document.querySelector('.pdp-tab-panel[data-tab="' + targetTab + '"]');
        if (targetPanel) targetPanel.classList.add('active');
      });
    });
  }

  /* ----------------------------------------------------------
     PDP GALLERY THUMBNAILS
  ---------------------------------------------------------- */
  const thumbs = document.querySelectorAll('.pdp-thumb');
  const mainImg = document.querySelector('.pdp-main-image img');

  if (thumbs.length > 0 && mainImg) {
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        thumbs.forEach(function (t) { t.classList.remove('active'); });
        this.classList.add('active');
        const newSrc = this.querySelector('img') && this.querySelector('img').src;
        if (newSrc) mainImg.src = newSrc;
      });
    });
  }

  /* ----------------------------------------------------------
     ADD TO CART FEEDBACK
  ---------------------------------------------------------- */
  const productForms = document.querySelectorAll('.pdp-product-form');

  productForms.forEach(function (form) {
    form.addEventListener('submit', function (e) {
      const submitBtn = form.querySelector('.atc-btn');
      if (!submitBtn) return;
      const originalText = submitBtn.textContent;
      submitBtn.textContent = 'Adding...';
      submitBtn.disabled = true;
      setTimeout(function () {
        submitBtn.textContent = originalText;
        submitBtn.disabled = false;
      }, 2000);
    });
  });

  /* ----------------------------------------------------------
     CART: QUANTITY UPDATE IN CART PAGE
  ---------------------------------------------------------- */
  document.querySelectorAll('.cart-qty-input').forEach(function (input) {
    input.addEventListener('change', function () {
      const line = this.dataset.line;
      const qty = parseInt(this.value, 10);
      if (line && !isNaN(qty)) {
        updateCartItem(line, qty);
      }
    });
  });

  function updateCartItem(line, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
    .then(function (res) { return res.json(); })
    .then(function (cart) {
      window.location.reload();
    })
    .catch(function (err) {
      console.error('Cart update error:', err);
    });
  }

  /* ----------------------------------------------------------
     ANNOUNCEMENT BAR CLOSE (optional)
  ---------------------------------------------------------- */
  const annBarClose = document.querySelector('.ann-bar__close');
  if (annBarClose) {
    annBarClose.addEventListener('click', function () {
      const bar = document.querySelector('.ann-bar-wrapper');
      if (bar) {
        bar.style.display = 'none';
        sessionStorage.setItem('tapios_ann_closed', '1');
      }
    });
  }
  if (sessionStorage.getItem('tapios_ann_closed') === '1') {
    const bar = document.querySelector('.ann-bar-wrapper');
    if (bar) bar.style.display = 'none';
  }

  /* ----------------------------------------------------------
     SMOOTH SCROLL FOR ANCHOR LINKS
  ---------------------------------------------------------- */
  document.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
    anchor.addEventListener('click', function (e) {
      const target = document.querySelector(this.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  /* ----------------------------------------------------------
     NEWSLETTER FORM SUCCESS MESSAGE
  ---------------------------------------------------------- */
  const newsletterForm = document.querySelector('#newsletter-form');
  if (newsletterForm) {
    if (window.location.search.indexOf('customer_posted=true') > -1 ||
        document.querySelector('[data-form-success]')) {
      const successMsg = document.querySelector('.newsletter-success');
      if (successMsg) successMsg.style.display = 'block';
    }
  }

});
